<template>
  <div class="col-sm-12">
    <div
      class="data-list-item add"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="draw-polygon"
          class="card-body-icon"
        />
      </div>
    </div>
      <div class="col-sm-12 my-2 list-content nopads">
          <Transition name="fade">
              <div
                  v-if="areaGroups.length > 0"
                  class="list-content result-table pointer"
              >
                  <vue3-datatable
                      ref="resultTable"
                      :rows="areaGroups"
                      :columns="fields"
                      :pagination="false"
                      :sticky-header="true"
                      height="85vh"
                      :sortable="true"
                      skin="bh-table-compact"
                      row-class="routa-table-row"
                      cell-class="routa-table-cell"
                      @row-click="rowClicked"
                  />
              </div>
          </Transition>
      </div>
  </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: 'AreaGroupList',
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('common.name'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    props: {
        areaGroups: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    methods: {
        rowClicked(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
